import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/Home'
import New from '../pages/New'
import More from '../pages/More'
import Case from '../pages/Case'
import Mains from '../pages/Mains'
import Mased from '../pages/Mased'
import Alge from '../pages/Alge'
import Handrs from '../pages/Handrs'
import Industry from '../pages/Industry'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'home'
  },
  {
    path: '/home',
    component: Home,
    name: 'Home'
  },
  {
    path: '/new/:news_id',
    component: New,
    name: 'New'
  },
  {
    path: '/more',
    component: More,
    name: 'More'
  },
  {
    path: '/case',
    component: Case,
    name: 'case'
  },
  {
    path: '/mains',
    component: Mains,
    name: 'Mains'
  },
  {
    path: '/mased',
    component: Mased,
    name: 'Mased'
  },
  {
    path: '/alge',
    component: Alge,
    name: 'Alge'
  },
  {
    path: '/handrs',
    component: Handrs,
    name: 'Handrs'
  },
  {
    path: '/industry',
    component: Industry,
    name: 'Industry'
  }
]

const router = new VueRouter({

  mode: 'hash',

  routes
})
// router.beforeEach((to, from, next) => {
//   if (to.path === '/login') {
//     next()
//   } else {
//     const token = localStorage.getItem('token')
//     if (!token) {
//       router.push('/login')
//       // return表示终止当前判断
//     } else {
//       next()
//     }
//   }
// })

export default router
